import React, { Component } from "react";
import { CommonLoader } from "../../../common/CommonLoader";
import { formatAmount } from "../../../../services/utils";

class CotisantStatsCompare extends Component {
  
  formatCotisationText(period) {
    const [year, month] = period.split('-').map(Number);
    const monthPadded = month.toString().padStart(2, '0'); // Ensure two digits
    const lastDay = new Date(year, month, 0).getDate(); // Get last day of the month

    return `Comparaison du nombre total des cotisations et le chiffre d'affaire du 01/${monthPadded} au ${lastDay}/${monthPadded}`;
  }
  
  render() {
    const { totalCotisations, categories, fetchingNbrCotisantByFormat, currentYear, formattedDataCompare, nbrCotisantByFormatCompareFetch, formattedCADataCurrentYear, formattedCADataPrevYear, caCotisantByFormatCompareFetch, fetchingCACotisantByFormat, associativeMembership, fetchingMembershipAssociative, membershipAssociativeComapre, membershipAssociativeComapreFetch, frequency, month, visibleKeys, onToggleKey } = this.props;

    const totalCotisationsCurrentYear = categories.reduce((sum, cat) => sum + cat.total, 0);
    const totalCACurrentYear = formattedCADataCurrentYear.categories.reduce((sum, cat) => sum + cat.total, 0);

    const totalCotisationsPrevYear = formattedDataCompare.categories.reduce((sum, cat) => sum + cat.total, 0);
    const totalCAPrevYear = formattedCADataPrevYear.categories.reduce((sum, cat) => sum + (cat ? cat.total : 0), 0);

    const safeDivide = (num, den) => {
      if (!den || isNaN(num) || isNaN(den)) return 0;
      return num / den;
    };

    return (
      <div style={{ 
        background: "#F9FAFB", 
        padding: "20px", 
        borderRadius: "10px", 
        width: "100%", 
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)" 
      }}>
        {
            fetchingNbrCotisantByFormat || nbrCotisantByFormatCompareFetch || caCotisantByFormatCompareFetch || fetchingCACotisantByFormat || fetchingMembershipAssociative || membershipAssociativeComapreFetch
            ? 
            <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"}/>
            :
            <React.Fragment>
                {/* Total Cotisations */}
                <p style={{ textAlign: "center", fontSize: "14px", color: "#333", margin: "5px 0 20px" }}>
                    {frequency === 'DAILY' && this.formatCotisationText(month)}
                    {frequency === 'MONTHLY' && `Comparaison du nombre total des cotisations et le chiffre d'affaire du Octobre ${currentYear-1} au Décembre ${currentYear}`}
                </p>
                
                <div style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "14px", color: "#29394D" }}>
                    <span style={{width: '33.5%'}}></span>
                    <span style={{width: '30.75%', textAlign: 'end', opacity: 0.7 }}>{currentYear - 1}</span>
                    <span style={{width: '30.75%', textAlign: 'end'}}>{currentYear}</span>
                    <span style={{width: '5%'}}></span>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "14px", color: "#29394D" }}>
                  <span style={{width: '33.5%'}}></span>
                  <span style={{width: '13%', textAlign: 'start', paddingLeft: '20px', opacity: 0.7}}>Cotisation</span>
                  <span style={{width: '17.75%', textAlign: 'end', opacity: 0.7}}>C.A</span>
                  <span style={{width: '13%', textAlign: 'start', paddingLeft: '20px'}}>Cotisation</span>
                  <span style={{width: '17.75%', textAlign: 'end'}}>C.A</span>
                  <span style={{width: '5%'}}></span>
                </div>

                {/* Categories */}
                {categories.map((category, index) => (
                <div key={index} style={{ marginTop: "15px" }}>
                    {/* Category Header */}
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", opacity: visibleKeys.includes(category.name) ? 1 : 0.5 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px", width: '22.5%' }}>
                          <span style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          backgroundColor: category.color
                          }}></span>
                          <span style={{ fontWeight: "500", fontSize: "16px", color: "#29394D" }}>{category.name}</span>
                      </div>
                      {
                      (parseFloat(((((formattedCADataCurrentYear.categories[index].total / 100) - (formattedCADataPrevYear.categories[index].total / 100)) / (formattedCADataPrevYear.categories[index].total / 100)) * 100).toFixed(2))) > 0 
                      ? 
                      <div style={{ display: "flex", alignItems: "baseline", gap: "5px", paddingLeft: '5px', width: '11%' }}>
                        <img src="/img/icons/manage-BM/BM_plus.svg"/>
                        <span className={'ml-1'} style={{color: '#02af8e'}}>{Math.abs(parseFloat(((((formattedCADataCurrentYear.categories[index].total / 100) - (formattedCADataPrevYear.categories[index].total / 100)) / (formattedCADataPrevYear.categories[index].total / 100 == 0 ? formattedCADataCurrentYear.categories[index].total / 100 : formattedCADataPrevYear.categories[index].total / 100)) * 100).toFixed(2)))}%</span>
                      </div> 
                      : 
                      (parseFloat(((((formattedCADataCurrentYear.categories[index].total / 100) - (formattedCADataPrevYear.categories[index].total / 100)) / (formattedCADataPrevYear.categories[index].total / 100)) * 100).toFixed(2))) < 0 
                      ?
                      <div style={{ display: "flex", alignItems: "baseline", gap: "5px", paddingLeft: '5px', width: '11%' }}>
                        <img src="/img/icons/manage-BM/BM_moins.svg"/>
                        <span className={'ml-1'} style={{color: '#fe3745'}}>{Math.abs(parseFloat(((((formattedCADataCurrentYear.categories[index].total / 100) - (formattedCADataPrevYear.categories[index].total / 100)) / (formattedCADataPrevYear.categories[index].total / 100 == 0 ? formattedCADataCurrentYear.categories[index].total / 100 : formattedCADataPrevYear.categories[index].total / 100)) * 100).toFixed(2)))}%</span>
                      </div>
                      :
                      <span style={{width: '11%'}} />
                      }
                      <span style={{ fontWeight: "500", color: category.color, width: '13%', textAlign: 'start', paddingLeft: '20px', opacity: 0.7 }}>{category.name === 'Fiduciaire' ? (formattedDataCompare.categories[index].total + (formattedDataCompare.categories[0].subCategories[4] ? formattedDataCompare.categories[0].subCategories[4].count : 0)) : formattedDataCompare.categories[index].total - (formattedDataCompare.categories[0].subCategories[4] ? formattedDataCompare.categories[0].subCategories[4].count : 0)}</span>
                      <span style={{ fontWeight: "500", color: category.color, width: '17.75%', textAlign: 'end', opacity: 0.7 }}>{formattedCADataPrevYear.categories[index] ? formatAmount(formattedCADataPrevYear.categories[index].total) : 0}</span>
                      <span style={{ fontWeight: "500", color: category.color, width: '13%', textAlign: 'start', paddingLeft: '20px' }}>{category.name === 'Fiduciaire' ? (category.total + (categories[0].subCategories[4] ? categories[0].subCategories[4].count : 0)) : category.total - (categories[0].subCategories[4] ? categories[0].subCategories[4].count : 0)}</span>
                      <span style={{ fontWeight: "500", color: category.color, width: '17.75%', textAlign: 'end' }}>{formatAmount(formattedCADataCurrentYear.categories[index].total)}</span>
                      <span style={{ 
                        fontWeight: "700", 
                        width: '5%', 
                        fontSize: "18px", 
                        textAlign: 'end', 
                        cursor: 'pointer',
                        backgroundColor: '#F1F2F4',
                        borderRadius: '50%',
                        height: '26px',
                        width: '26px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '5%'
                      }} onClick={() => {
                        onToggleKey(category.name);
                      }}>
                        {category.name === 'Fiduciaire' ? (<img  src={visibleKeys.includes('Fiduciaire') ? "/img/icons/event-stats/eye-2.svg" : "/img/icons/event-stats/eye-1.svg"} alt=""/>) : null}
                        {category.name === 'Statutaire' ? (<img  src={visibleKeys.includes('Statutaire') ? "/img/icons/event-stats/eye-2.svg" : "/img/icons/event-stats/eye-1.svg"} alt=""/>) : null}
                      </span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", opacity: visibleKeys.includes(category.name) ? 1 : 0.5 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px", width: '22.5%' }}>
                          <span style={{ fontWeight: "500", fontSize: "14px", color: "#29394D" }}>Prix moyen par achat</span>
                      </div>
                      {
                      (parseFloat(((((safeDivide(
                            (formattedCADataCurrentYear.categories &&
                            formattedCADataCurrentYear.categories[index] &&
                            formattedCADataCurrentYear.categories[index].total) || 0,

                            category.name === 'Fiduciaire'
                              ? (category.total || 0) +
                                ((categories &&
                                  categories[0] &&
                                  categories[0].subCategories &&
                                  categories[0].subCategories[4] &&
                                  categories[0].subCategories[4].count) || 0)

                              : (category.total || 0) -
                                ((categories &&
                                  categories[0] &&
                                  categories[0].subCategories &&
                                  categories[0].subCategories[4] &&
                                  categories[0].subCategories[4].count) || 0)
                          )) - (safeDivide(
                            (formattedCADataPrevYear.categories &&
                            formattedCADataPrevYear.categories[index] &&
                            formattedCADataPrevYear.categories[index].total) || 0,

                            category.name === 'Fiduciaire'
                              ? ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                + ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)

                              : ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                - ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)
                          ))) / (safeDivide(
                            (formattedCADataPrevYear.categories &&
                            formattedCADataPrevYear.categories[index] &&
                            formattedCADataPrevYear.categories[index].total) || 0,

                            category.name === 'Fiduciaire'
                              ? ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                + ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)

                              : ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                - ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)
                          ))) * 100).toFixed(2))) > 0 
                      ? 
                      <div style={{ display: "flex", alignItems: "baseline", gap: "5px", paddingLeft: '5px', width: '11%' }}>
                        <img src="/img/icons/manage-BM/BM_plus.svg"/>
                        <span className={'ml-1'} style={{color: '#02af8e'}}>{Math.abs(parseFloat(((((safeDivide(
                            (formattedCADataCurrentYear.categories &&
                            formattedCADataCurrentYear.categories[index] &&
                            formattedCADataCurrentYear.categories[index].total) || 0,

                            category.name === 'Fiduciaire'
                              ? (category.total || 0) +
                                ((categories &&
                                  categories[0] &&
                                  categories[0].subCategories &&
                                  categories[0].subCategories[4] &&
                                  categories[0].subCategories[4].count) || 0)

                              : (category.total || 0) -
                                ((categories &&
                                  categories[0] &&
                                  categories[0].subCategories &&
                                  categories[0].subCategories[4] &&
                                  categories[0].subCategories[4].count) || 0)
                          )) - (safeDivide(
                            (formattedCADataPrevYear.categories &&
                            formattedCADataPrevYear.categories[index] &&
                            formattedCADataPrevYear.categories[index].total) || 0,

                            category.name === 'Fiduciaire'
                              ? ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                + ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)

                              : ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                - ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)
                          ))) / (safeDivide(
                            (formattedCADataPrevYear.categories &&
                            formattedCADataPrevYear.categories[index] &&
                            formattedCADataPrevYear.categories[index].total) || 0,

                            category.name === 'Fiduciaire'
                              ? ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                + ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)

                              : ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                - ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)
                          ) == 0 ? safeDivide(
                            (formattedCADataCurrentYear.categories &&
                            formattedCADataCurrentYear.categories[index] &&
                            formattedCADataCurrentYear.categories[index].total) || 0,

                            category.name === 'Fiduciaire'
                              ? (category.total || 0) +
                                ((categories &&
                                  categories[0] &&
                                  categories[0].subCategories &&
                                  categories[0].subCategories[4] &&
                                  categories[0].subCategories[4].count) || 0)

                              : (category.total || 0) -
                                ((categories &&
                                  categories[0] &&
                                  categories[0].subCategories &&
                                  categories[0].subCategories[4] &&
                                  categories[0].subCategories[4].count) || 0)
                          ) : safeDivide(
                            (formattedCADataPrevYear.categories &&
                            formattedCADataPrevYear.categories[index] &&
                            formattedCADataPrevYear.categories[index].total) || 0,

                            category.name === 'Fiduciaire'
                              ? ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                + ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)

                              : ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                - ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)
                          ))) * 100).toFixed(2)))}%</span>
                      </div> 
                      : 
                      (parseFloat(((((safeDivide(
                            (formattedCADataCurrentYear.categories &&
                            formattedCADataCurrentYear.categories[index] &&
                            formattedCADataCurrentYear.categories[index].total) || 0,

                            category.name === 'Fiduciaire'
                              ? (category.total || 0) +
                                ((categories &&
                                  categories[0] &&
                                  categories[0].subCategories &&
                                  categories[0].subCategories[4] &&
                                  categories[0].subCategories[4].count) || 0)

                              : (category.total || 0) -
                                ((categories &&
                                  categories[0] &&
                                  categories[0].subCategories &&
                                  categories[0].subCategories[4] &&
                                  categories[0].subCategories[4].count) || 0)
                          )) - (safeDivide(
                            (formattedCADataPrevYear.categories &&
                            formattedCADataPrevYear.categories[index] &&
                            formattedCADataPrevYear.categories[index].total) || 0,

                            category.name === 'Fiduciaire'
                              ? ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                + ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)

                              : ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                - ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)
                          ))) / (safeDivide(
                            (formattedCADataPrevYear.categories &&
                            formattedCADataPrevYear.categories[index] &&
                            formattedCADataPrevYear.categories[index].total) || 0,

                            category.name === 'Fiduciaire'
                              ? ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                + ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)

                              : ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                - ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)
                          ))) * 100).toFixed(2))) < 0 
                      ?
                      <div style={{ display: "flex", alignItems: "baseline", gap: "5px", paddingLeft: '5px', width: '11%' }}>
                        <img src="/img/icons/manage-BM/BM_moins.svg"/>
                        <span className={'ml-1'} style={{color: '#fe3745'}}>{Math.abs(parseFloat(((((safeDivide(
                            (formattedCADataCurrentYear.categories &&
                            formattedCADataCurrentYear.categories[index] &&
                            formattedCADataCurrentYear.categories[index].total) || 0,

                            category.name === 'Fiduciaire'
                              ? (category.total || 0) +
                                ((categories &&
                                  categories[0] &&
                                  categories[0].subCategories &&
                                  categories[0].subCategories[4] &&
                                  categories[0].subCategories[4].count) || 0)

                              : (category.total || 0) -
                                ((categories &&
                                  categories[0] &&
                                  categories[0].subCategories &&
                                  categories[0].subCategories[4] &&
                                  categories[0].subCategories[4].count) || 0)
                          )) - (safeDivide(
                            (formattedCADataPrevYear.categories &&
                            formattedCADataPrevYear.categories[index] &&
                            formattedCADataPrevYear.categories[index].total) || 0,

                            category.name === 'Fiduciaire'
                              ? ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                + ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)

                              : ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                - ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)
                          ))) / (safeDivide(
                            (formattedCADataPrevYear.categories &&
                            formattedCADataPrevYear.categories[index] &&
                            formattedCADataPrevYear.categories[index].total) || 0,

                            category.name === 'Fiduciaire'
                              ? ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                + ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)

                              : ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                - ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)
                          ) == 0 ? safeDivide(
                            (formattedCADataCurrentYear.categories &&
                            formattedCADataCurrentYear.categories[index] &&
                            formattedCADataCurrentYear.categories[index].total) || 0,

                            category.name === 'Fiduciaire'
                              ? (category.total || 0) +
                                ((categories &&
                                  categories[0] &&
                                  categories[0].subCategories &&
                                  categories[0].subCategories[4] &&
                                  categories[0].subCategories[4].count) || 0)

                              : (category.total || 0) -
                                ((categories &&
                                  categories[0] &&
                                  categories[0].subCategories &&
                                  categories[0].subCategories[4] &&
                                  categories[0].subCategories[4].count) || 0)
                          ) : safeDivide(
                            (formattedCADataPrevYear.categories &&
                            formattedCADataPrevYear.categories[index] &&
                            formattedCADataPrevYear.categories[index].total) || 0,

                            category.name === 'Fiduciaire'
                              ? ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                + ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)

                              : ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                - ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)
                          ))) * 100).toFixed(2)))}%</span>
                      </div>
                      :
                      <span style={{width: '11%'}} />
                      }
                      <span style={{ fontWeight: "500", color: category.color, width: '30.75%', textAlign: 'end', paddingLeft: '20px', opacity: 0.7 }}>
                      {
                        formatAmount(
                          safeDivide(
                            (formattedCADataPrevYear.categories &&
                            formattedCADataPrevYear.categories[index] &&
                            formattedCADataPrevYear.categories[index].total) || 0,

                            category.name === 'Fiduciaire'
                              ? ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                + ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)

                              : ((formattedDataCompare.categories &&
                                  formattedDataCompare.categories[index] &&
                                  formattedDataCompare.categories[index].total) || 0)
                                - ((formattedDataCompare.categories &&
                                    formattedDataCompare.categories[0] &&
                                    formattedDataCompare.categories[0].subCategories &&
                                    formattedDataCompare.categories[0].subCategories[4] &&
                                    formattedDataCompare.categories[0].subCategories[4].count) || 0)
                          )
                        )
                      }
                    </span>

                    <span style={{ fontWeight: "500", color: category.color, width: '30.75%', textAlign: 'end', paddingLeft: '20px' }}>
                      {
                        formatAmount(
                          safeDivide(
                            (formattedCADataCurrentYear.categories &&
                            formattedCADataCurrentYear.categories[index] &&
                            formattedCADataCurrentYear.categories[index].total) || 0,

                            category.name === 'Fiduciaire'
                              ? (category.total || 0) +
                                ((categories &&
                                  categories[0] &&
                                  categories[0].subCategories &&
                                  categories[0].subCategories[4] &&
                                  categories[0].subCategories[4].count) || 0)

                              : (category.total || 0) -
                                ((categories &&
                                  categories[0] &&
                                  categories[0].subCategories &&
                                  categories[0].subCategories[4] &&
                                  categories[0].subCategories[4].count) || 0)
                          )
                        )
                      }
                    </span>
                    <span style={{ width: '5%' }}></span>
                    </div>

                    {/* Subcategories */}
                    <div style={{ borderTop: "1px solid #D1D5DB", marginTop: "8px", paddingTop: "8px" }}>
                    {
                    category.name == 'Fiduciaire'
                    ?
                    category.subCategories.map((sub, idx) => (
                      <React.Fragment key={idx}>
                        <div key={idx} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "14px", color: "#29394D", opacity: visibleKeys.includes(category.name) ? 1 : 0.5 }}>
                          <span style={{width: '27.5%'}}>{sub.name}</span>
                        </div>
                        <div key={idx} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "14px", color: "#29394D", opacity: visibleKeys.includes(category.name) ? 1 : 0.5 }}>
                            <span style={{width: '22.5%', paddingLeft: '10px'}}>{'Membres Non Associés'}</span>
                              {
                                (parseFloat((((formattedCADataCurrentYear.categories[index].subCategories[idx] ? (formattedCADataCurrentYear.categories[index].subCategories[idx].count / 100) : 0) - (formattedCADataPrevYear.categories[index].subCategories[idx] ? (formattedCADataPrevYear.categories[index].subCategories[idx].count / 100) : 0)) / (formattedCADataPrevYear.categories[index].subCategories[idx] ? (formattedCADataPrevYear.categories[index].subCategories[idx].count / 100) : 0) * 100).toFixed(2))) > 0
                                ?
                                <div style={{ display: "flex", alignItems: "baseline", gap: "5px", paddingLeft: '5px', width: '11%' }}>
                                  <img src="/img/icons/manage-BM/BM_plus.svg"/>
                                  <span className={'ml-1'} style={{color: '#02af8e'}}>
                                    {Math.abs(parseFloat((((formattedCADataCurrentYear.categories[index].subCategories[idx] ? (formattedCADataCurrentYear.categories[index].subCategories[idx].count / 100) : 0) - (formattedCADataPrevYear.categories[index].subCategories[idx] ? (formattedCADataPrevYear.categories[index].subCategories[idx].count / 100) : 0)) / (formattedCADataPrevYear.categories[index].subCategories[idx] ? (formattedCADataPrevYear.categories[index].subCategories[idx].count / 100 == 0 ? formattedCADataCurrentYear.categories[index].subCategories[idx].count / 100 : formattedCADataPrevYear.categories[index].subCategories[idx].count / 100) : 0) * 100).toFixed(2)))}%
                                  </span>
                                </div>
                                : 
                                (parseFloat((((formattedCADataCurrentYear.categories[index].subCategories[idx] ? (formattedCADataCurrentYear.categories[index].subCategories[idx].count / 100) : 0) - (formattedCADataPrevYear.categories[index].subCategories[idx] ? (formattedCADataPrevYear.categories[index].subCategories[idx].count / 100) : 0)) / (formattedCADataPrevYear.categories[index].subCategories[idx] ? (formattedCADataPrevYear.categories[index].subCategories[idx].count / 100) : 0) * 100).toFixed(2))) < 0
                                ?
                                <div style={{ display: "flex", alignItems: "baseline", gap: "5px", paddingLeft: '5px', width: '11%' }}>
                                  <img src="/img/icons/manage-BM/BM_moins.svg"/>
                                  <span className={'ml-1'} style={{color: '#fe3745'}}>
                                    {Math.abs(parseFloat((((formattedCADataCurrentYear.categories[index].subCategories[idx] ? (formattedCADataCurrentYear.categories[index].subCategories[idx].count / 100) : 0) - (formattedCADataPrevYear.categories[index].subCategories[idx] ? (formattedCADataPrevYear.categories[index].subCategories[idx].count / 100) : 0)) / (formattedCADataPrevYear.categories[index].subCategories[idx] ? (formattedCADataPrevYear.categories[index].subCategories[idx].count / 100 == 0 ? formattedCADataCurrentYear.categories[index].subCategories[idx].count / 100 : formattedCADataPrevYear.categories[index].subCategories[idx].count / 100) : 0) * 100).toFixed(2)))}%
                                  </span>
                                </div>
                                :
                                <span style={{width: '9%'}} />
                              }
                            <span style={{width: '13%', textAlign: 'start', paddingLeft: '20px', display: 'flex', alignItems: 'baseline', opacity: 0.7}}>{formattedDataCompare.categories[index].subCategories[idx] ? formattedDataCompare.categories[index].subCategories[idx].count : 0}</span>
                            <span style={{width: '17.75%', justifyContent: 'end', display: 'flex', alignItems: 'baseline', opacity: 0.7}}>{formattedCADataPrevYear.categories[index].subCategories[idx] ? formatAmount(formattedCADataPrevYear.categories[index].subCategories[idx].count) : 0}</span>
                            <span style={{width: '13%', textAlign: 'start', paddingLeft: '20px', display: 'flex', alignItems: 'baseline'}}>{sub.count}</span>
                            <span style={{width: '17.75%', justifyContent: 'end', display: 'flex', alignItems: 'baseline'}}>{formattedCADataCurrentYear.categories[index].subCategories[idx] ? formatAmount(formattedCADataCurrentYear.categories[index].subCategories[idx].count) : 0}</span>
                            <span style={{width: '26px'}}></span>
                        </div>
                      </React.Fragment>
                    ))
                    :
                    category.subCategories.slice(0, -1).map((sub, idx) => (
                      <div key={idx} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "14px", color: "#29394D", opacity: visibleKeys.includes(category.name) ? 1 : 0.5 }}>
                          <span style={{width: '22.5%'}}>{sub.name}</span>
                          {
                            (parseFloat((((formattedCADataCurrentYear.categories[index].subCategories[idx] ? (formattedCADataCurrentYear.categories[index].subCategories[idx].count / 100) : 0) - (formattedCADataPrevYear.categories[index].subCategories[idx] ? (formattedCADataPrevYear.categories[index].subCategories[idx].count / 100) : 0)) / (formattedCADataPrevYear.categories[index].subCategories[idx] ? (formattedCADataPrevYear.categories[index].subCategories[idx].count / 100) : 0) * 100).toFixed(2))) > 0
                            ?
                            <div style={{ display: "flex", alignItems: "baseline", gap: "5px", paddingLeft: '5px', width: '11%' }}>
                              <img src="/img/icons/manage-BM/BM_plus.svg"/>
                              <span className={'ml-1'} style={{color: '#02af8e'}}>
                                {Math.abs(parseFloat((((formattedCADataCurrentYear.categories[index].subCategories[idx] ? (formattedCADataCurrentYear.categories[index].subCategories[idx].count / 100) : 0) - (formattedCADataPrevYear.categories[index].subCategories[idx] ? (formattedCADataPrevYear.categories[index].subCategories[idx].count / 100) : 0)) / (formattedCADataPrevYear.categories[index].subCategories[idx] ? (formattedCADataPrevYear.categories[index].subCategories[idx].count / 100 == 0 ? formattedCADataCurrentYear.categories[index].subCategories[idx].count / 100 : formattedCADataPrevYear.categories[index].subCategories[idx].count / 100) : 0) * 100).toFixed(2)))}%
                              </span>
                            </div>
                            :
                            (parseFloat((((formattedCADataCurrentYear.categories[index].subCategories[idx] ? (formattedCADataCurrentYear.categories[index].subCategories[idx].count / 100) : 0) - (formattedCADataPrevYear.categories[index].subCategories[idx] ? (formattedCADataPrevYear.categories[index].subCategories[idx].count / 100) : 0)) / (formattedCADataPrevYear.categories[index].subCategories[idx] ? (formattedCADataPrevYear.categories[index].subCategories[idx].count / 100) : 0) * 100).toFixed(2))) < 0
                            ?
                            <div style={{ display: "flex", alignItems: "baseline", gap: "5px", paddingLeft: '5px', width: '11%' }}>
                              <img src="/img/icons/manage-BM/BM_moins.svg"/>
                              <span className={'ml-1'} style={{color: '#fe3745'}}>
                                {Math.abs(parseFloat((((formattedCADataCurrentYear.categories[index].subCategories[idx] ? (formattedCADataCurrentYear.categories[index].subCategories[idx].count / 100) : 0) - (formattedCADataPrevYear.categories[index].subCategories[idx] ? (formattedCADataPrevYear.categories[index].subCategories[idx].count / 100) : 0)) / (formattedCADataPrevYear.categories[index].subCategories[idx] ? (formattedCADataPrevYear.categories[index].subCategories[idx].count / 100 == 0 ? formattedCADataCurrentYear.categories[index].subCategories[idx].count / 100 : formattedCADataPrevYear.categories[index].subCategories[idx].count / 100) : 0) * 100).toFixed(2)))}%
                              </span>
                            </div>
                            :
                            <span style={{width: '9%'}} />
                          }
                          <span style={{width: '13%', textAlign: 'start', paddingLeft: '20px', opacity: 0.7}}>{formattedDataCompare.categories[index].subCategories[idx] ? formattedDataCompare.categories[index].subCategories[idx].count : 0}</span>
                          <span style={{width: '17.75%', textAlign: 'end', opacity: 0.7}}>{formattedCADataPrevYear.categories[index].subCategories[idx] ? formatAmount(formattedCADataPrevYear.categories[index].subCategories[idx].count) : 0}</span>
                          <span style={{width: '13%', textAlign: 'start', paddingLeft: '20px'}}>{sub.count}</span>
                          <span style={{width: '17.75%', textAlign: 'end'}}>{formattedCADataCurrentYear.categories[index].subCategories[idx] ? formatAmount(formattedCADataCurrentYear.categories[index].subCategories[idx].count) : 0}</span>
                          <span style={{width: '26px'}}></span>
                      </div>
                    ))
                    }
                    </div>
                </div>
                ))}
                <div style={{ opacity: visibleKeys.includes('Fiduciaire') ? 1 : 0.5}}>
                  <div style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "14px", color: "#29394D" }}>
                    <span style={{width: '22.5%', paddingLeft: '10px'}}>{'Membres Associés'}</span>
                    <span style={{width: '11%'}}></span>
                    <span style={{width: '13%', textAlign: 'start', paddingLeft: '20px', opacity: 0.7}}>{formattedDataCompare.categories[0].subCategories[4] ? formattedDataCompare.categories[0].subCategories[4].count : 0}</span>
                    <span style={{width: '17.75%', textAlign: 'end', opacity: 0.7}}>{formatAmount(0)}</span>
                    <span style={{width: '13%', textAlign: 'start', paddingLeft: '20px'}}>{categories[0].subCategories[4] ? categories[0].subCategories[4].count : 0}</span>
                    <span style={{width: '17.75%', textAlign: 'end'}}>{formatAmount(0)}</span>
                    <span style={{width: '26px'}}></span>
                  </div>
                </div>

                {/* Total Row */}
                <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", fontSize: "16px", fontWeight: "bold", color: "#29394D", borderTop: "2px solid #D1D5DB", marginTop: "10px" }}>
                  <span style={{ width: '22.5%' }}>Total</span>
                  {
                    (parseFloat(((((totalCACurrentYear / 100) - (totalCAPrevYear / 100)) / (totalCAPrevYear / 100 == 0 ? totalCACurrentYear / 100 : totalCAPrevYear / 100)) * 100).toFixed(2))) > 0
                    ?
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", paddingLeft: '5px', width: '11%', fontSize: '14px', fontWeight: '500' }}>
                      <img src="/img/icons/manage-BM/BM_plus.svg"/>
                      <span className={'ml-1'} style={{color: '#02af8e'}}>{Math.abs(parseFloat(((((totalCACurrentYear / 100) - (totalCAPrevYear / 100)) / (totalCAPrevYear / 100 == 0 ? totalCACurrentYear / 100 : totalCAPrevYear / 100)) * 100).toFixed(2)))}%</span>
                    </div>
                    :
                    (parseFloat(((((totalCACurrentYear / 100) - (totalCAPrevYear / 100)) / (totalCAPrevYear / 100 == 0 ? totalCACurrentYear / 100 : totalCAPrevYear / 100)) * 100).toFixed(2))) < 0
                    ?
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", paddingLeft: '5px', width: '11%', fontSize: '14px', fontWeight: '500' }}>
                      <img src="/img/icons/manage-BM/BM_moins.svg"/>
                      <span className={'ml-1'} style={{color: '#fe3745'}}>{Math.abs(parseFloat(((((totalCACurrentYear / 100) - (totalCAPrevYear / 100)) / (totalCAPrevYear / 100 == 0 ? totalCACurrentYear / 100 : totalCAPrevYear / 100)) * 100).toFixed(2)))}%</span>
                    </div>
                    :
                    <span style={{width: '11%'}} />
                  }
                  <span style={{ width: '13%', textAlign: 'start', paddingLeft: '20px', opacity: 0.7 }}>{totalCotisationsPrevYear}</span>
                  <span style={{ width: '17.75%', textAlign: 'end', opacity: 0.7 }}>{formatAmount(totalCAPrevYear)}</span>
                  <span style={{ width: '13%', textAlign: 'start', paddingLeft: '20px' }}>{totalCotisationsCurrentYear}</span>
                  <span style={{ width: '17.75%', textAlign: 'end' }}>{formatAmount(totalCACurrentYear)}</span>
                  <span style={{ width: '26px' }}></span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "14px", fontWeight: "500", color: "#29394D" }}>
                  <span style={{ width: '22.5%' }}>Prix moyen par achat</span>
                  {
                    (parseFloat(((((safeDivide(
                        totalCACurrentYear || 0,
                        totalCotisationsCurrentYear || 0
                      )) - (safeDivide(
                        totalCAPrevYear || 0,
                        totalCotisationsPrevYear || 0
                      ))) / (safeDivide(
                        totalCAPrevYear || 0,
                        totalCotisationsPrevYear || 0
                      ) == 0 ? safeDivide(
                        totalCACurrentYear || 0,
                        totalCotisationsCurrentYear || 0
                      ) : safeDivide(
                        totalCAPrevYear || 0,
                        totalCotisationsPrevYear || 0
                      ))) * 100).toFixed(2))) > 0
                    ?
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", paddingLeft: '5px', width: '11%', fontSize: '14px', fontWeight: '500' }}>
                      <img src="/img/icons/manage-BM/BM_plus.svg"/>
                      <span className={'ml-1'} style={{color: '#02af8e'}}>{Math.abs(parseFloat(((((safeDivide(
                        totalCACurrentYear || 0,
                        totalCotisationsCurrentYear || 0
                      )) - (safeDivide(
                        totalCAPrevYear || 0,
                        totalCotisationsPrevYear || 0
                      ))) / (safeDivide(
                        totalCAPrevYear || 0,
                        totalCotisationsPrevYear || 0
                      ) == 0 ? safeDivide(
                        totalCACurrentYear || 0,
                        totalCotisationsCurrentYear || 0
                      ) : safeDivide(
                        totalCAPrevYear || 0,
                        totalCotisationsPrevYear || 0
                      ))) * 100).toFixed(2)))}%</span>
                    </div>
                    :
                    (parseFloat(((((safeDivide(
                        totalCACurrentYear || 0,
                        totalCotisationsCurrentYear || 0
                      )) - (safeDivide(
                        totalCAPrevYear || 0,
                        totalCotisationsPrevYear || 0
                      ))) / (safeDivide(
                        totalCAPrevYear || 0,
                        totalCotisationsPrevYear || 0
                      ) == 0 ? safeDivide(
                        totalCACurrentYear || 0,
                        totalCotisationsCurrentYear || 0
                      ) : safeDivide(
                        totalCAPrevYear || 0,
                        totalCotisationsPrevYear || 0
                      ))) * 100).toFixed(2))) < 0
                    ?
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", paddingLeft: '5px', width: '11%', fontSize: '14px', fontWeight: '500' }}>
                      <img src="/img/icons/manage-BM/BM_moins.svg"/>
                      <span className={'ml-1'} style={{color: '#fe3745'}}>{Math.abs(parseFloat(((((safeDivide(
                        totalCACurrentYear || 0,
                        totalCotisationsCurrentYear || 0
                      )) - (safeDivide(
                        totalCAPrevYear || 0,
                        totalCotisationsPrevYear || 0
                      ))) / (safeDivide(
                        totalCAPrevYear || 0,
                        totalCotisationsPrevYear || 0
                      ) == 0 ? safeDivide(
                        totalCACurrentYear || 0,
                        totalCotisationsCurrentYear || 0
                      ) : safeDivide(
                        totalCAPrevYear || 0,
                        totalCotisationsPrevYear || 0
                      ))) * 100).toFixed(2)))}%</span>
                    </div>
                    :
                    <span style={{width: '11%'}} />
                  }
                  <span style={{ width: '30.75%', textAlign: 'end', paddingLeft: '20px', opacity: 0.7 }}>
                    {formatAmount(
                      safeDivide(
                        totalCAPrevYear || 0,
                        totalCotisationsPrevYear || 0
                      )
                    )}
                  </span>
                  <span style={{ width: '30.75%', textAlign: 'end', paddingLeft: '20px' }}>
                    {formatAmount(
                      safeDivide(
                        totalCACurrentYear || 0,
                        totalCotisationsCurrentYear || 0
                      )
                    )}
                  </span>
                  <span style={{ width: '26px' }}></span>
                </div>
            </React.Fragment>
        }
      </div>
    );
  }
}

export default CotisantStatsCompare;



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/CotisantStatsCompare.js